import React from 'react';
import '../../../styles/style.css';

const LocationDescription = ({ name, description }) => {

  // исправляет проблему с \n и \\n
  const paragraphs = description
    ? description.split(/\r?\n|\\n/).filter(p => p.trim() !== '')
    : [];

  return (
    <div className="locationInfoWrapper">

      {/* Название */}
      <div className="locationNameWrapper flex-row">
        <h1 className="locationName">{name}</h1>
        <div className="locationNameYellowUnderneath"></div>
      </div>

      {/* Описание + линия */}
      <div className="descWithLine">

        <div className="verticalLine"></div>

        <div className="locationDescWrapper">
          <div className="locationDesc">

            {paragraphs.map((line, index) => (
              <p key={index}>{line}</p>
            ))}

          </div>
        </div>

      </div>

    </div>
  );
};

export default LocationDescription;